import { useGlobals } from 'hooks/useGlobals';
import { hasBannerUpgradePlanSlugs } from './constants';
import { ComboSlug, ProductCombo } from './types';

const useUserCombo = () => {
  const { user } = useGlobals();
  const combo = user?.data?.company?.combo ?? {};

  const comboSlug: ComboSlug = combo?.slug;

  const suggestedTruckers = combo?.products?.find((product: ProductCombo) => product.slug === 'suggested-trucker');

  const maxLimitView = suggestedTruckers ? suggestedTruckers.maxLimitView : 0;

  const hasBannerUpgrade = hasBannerUpgradePlanSlugs.includes(comboSlug);

  return { maxLimitView, hasBannerUpgrade };
};

export { useUserCombo };
